import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect, useState } from "react";
import "./Loading.scss";
import ReactDOM from "react-dom";

interface LoadingProps {
  parentId: string;
}

const Loading: React.FC<LoadingProps> = (props: LoadingProps) => {
  const [loadingContainer, setLoadingContainer] = useState<HTMLElement | null>(
    document.getElementById(props.parentId)
  );

  useEffect(() => {
    const checkParentElement = () => {
      const container = document.getElementById(props.parentId);

      if (!container) {
        setTimeout(checkParentElement, 100);
      } else {
        setLoadingContainer(container);
      }
    };

    checkParentElement();
  }, [props.parentId]);

  if (!loadingContainer) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className="loading-container">
      <CircularProgress className="center-xy" />
    </div>,
    loadingContainer
  );
};

export default Loading;
